import { Button, message, Modal, Select } from "antd"
import React, { Key, useEffect, useState } from "react"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { useActions } from "../../../hooks/useActions"
import { buildAudienceOptions } from "../hooks/helpers/audienceOptions.helper"

interface ISbSelectAudienceModalProps {
  selectedCampaignIds: Key[]
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const SbSelectAudienceModal = React.memo(function SbSelectAudienceModal({
  selectedCampaignIds,
  isOpen,
  setIsOpen,
}: ISbSelectAudienceModalProps) {
  const [selectedAudience, setSelectedAudience] = useState<string | null>(null)

  const { audiences, loaded } = useTypedSelector((state) => state.audiences)
  const { fetchAudiences, applySbAudienceToCampaigns } = useActions()

  useEffect(() => {
    if (isOpen) {
      fetchAudiences()
    }
  }, [isOpen])

  useEffect(() => {
    setSelectedAudience(null)
  }, [isOpen])

  function applyToSelectedCampaigns() {
    if (selectedCampaignIds.length === 0) {
      message.error("Please select campaigns")
      return
    }

    if (!selectedAudience) {
      message.error("Please select an audience")
      return
    }

    applySbAudienceToCampaigns(selectedCampaignIds.map(String), selectedAudience)
    setIsOpen(false)
    message.success("Audience applied to selected campaigns")
  }

  return (
    <Modal
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={<Button onClick={applyToSelectedCampaigns}>Apply to selected</Button>}
      width={"40%"}
    >
      <Select
        options={buildAudienceOptions(audiences)}
        value={selectedAudience}
        onChange={(value) => setSelectedAudience(value)}
        style={{ width: "85%" }}
        placeholder="Select Audience"
        loading={loaded}
      />
    </Modal>
  )
})

export default SbSelectAudienceModal
